import {useIntl} from "react-intl";

function Privacy() {
  const { formatMessage, locale } = useIntl();
  const fm = id => formatMessage({id});

  return (
    <div className="bg-[#F5F4EE] px-[7.5%] py-[20px] md:py-[50px] mt-20 md:mt-[100px]">
      {/* Title */}
      <div className="font-['Bebas_Neue'] font-normal text-2xl md:text-[48px] text-black mb-6 md:mb-8">
        {fm('Privacy Policy')}
      </div>

      {/* Content */}
      <div className="font-['Open_Sans'] font-normal text-xs md:text-base text-black">
        {/* Introduction */}
        <div className="mb-5">
          {
            locale === 'en' ? (
              <>{fm('The Nguyễn-Phương Family recognizes the importance of protecting your personal and financial information when you visit our website located at       https://www.nguyenphuongfamily.org/ ("Website"). The following information is designed to help you understand the information collection practices at this Website.')}</>
            ) : (
              <>Gia đình Nguyễn-Phương nhận thấy tầm quan trọng của việc bảo vệ thông tin cá nhân và tài chính của bạn khi bạn truy cập trang web của chúng tôi tại https://www.nguyenphuongfamily.org/ ("Trang web"). Thông tin sau đây được thiết kế để giúp bạn hiểu các hoạt động thu thập thông tin tại Trang web này.</>
            )
          }
        </div>

        <p className="mb-5"></p>

        <div className="mb-5">
          {fm('By visiting this Website, you are accepting the practices described in this Privacy Policy. If you do not agree to this policy, please do not use this Website. Please review the terms and conditions on the Website to learn of other terms and conditions applicable to your use of this Website.')}
        </div>

        {/* Information Collection and Use */}
        <div className="font-['Open_Sans'] font-bold text-xs md:text-base leading-[22px] text-black my-[10px] md:my-5 underline">
          {fm('Information Collection and Use')}
        </div>

        {/* Methods of Information Collection */}
        <div className="font-['Open_Sans'] font-bold text-xs md:text-base leading-[22px] text-black my-[10px] md:my-5">
          {fm('Methods of Information Collection')}
        </div>

        <div className="mb-5">
          {fm('We may receive personally identifiable information you submit to or through our Website. By disclosing your personally identifiable information to us via our Website, you consent to our collection, use and disclosure of your personally identifiable information for the purposes as set out in this Privacy Policy. Failure to provide such personally identifiable information may result in the Nguyễn-Phương Family being unable to provide you with the services or information requested.')}
        </div>

        {/* Information Collected and Purpose */}
        <div className="font-['Open_Sans'] font-bold text-xs md:text-base leading-[22px] text-black my-[10px] md:my-5">
          {fm('Information Collected and Purpose of Information Collection')}
        </div>

        <div className="mb-5">
          {fm('The types of personally identifiable information that may be collected at our Website include information you provided to us through the "Contact Us" page (which may include your name and email address).')}
        </div>

        {/* Use of Personally Identifiable Information */}
        <div className="font-['Open_Sans'] font-bold text-xs md:text-base leading-[22px] text-black my-[10px] md:my-5">
          {fm('Use of Personally Identifiable Information')}
        </div>

        <div className="mb-5">
          {
            locale === 'en' ? (
              <>
                <div className="mb-3">
                  {fm('The personally identifiable information you submit to or through our Website is used only for the following purposes:')}
                </div>
                <ul className="pl-5 list-disc md:pl-[30px] mb-3">
                  <li>{fm('Responding to your inquiry sent to us; and')}</li>
                  <li>{fm('Other directly related purposes.')}</li>
                </ul>
                <p className="mb-3"></p>
                <div>
                  {fm('We will not sell, share, rent or otherwise disclose or transfer your personally identifiable information to others without your consent.')}
                </div>
              </>
            ) : (
              <>
                <div className="mb-3">
                  Thông tin nhận dạng cá nhân bạn gửi đến hoặc thông qua Trang web của chúng tôi chỉ được sử dụng cho các mục đích sau:
                </div>
                <ul className="pl-5 md:pl-[30px] mb-3">
                  <li>Trả lời yêu cầu của bạn gửi cho chúng tôi; </li>
                  <li>Và Các mục đích liên quan trực tiếp khác. </li>
                </ul>
                <p className="mb-3"></p>
                <div>
                  Chúng tôi sẽ không bán, chia sẻ, cho thuê hoặc tiết lộ hay chuyển giao thông tin nhận dạng cá nhân của bạn cho người khác mà không có sự đồng ý của bạn.
                </div>
              </>
            )
          }
        </div>

        {/* Retention Period */}
        <div className="font-['Open_Sans'] font-bold text-xs md:text-base leading-[22px] text-black my-[10px] md:my-5">
          {fm('Retention Period')}
        </div>

        <div className="mb-5">
          {fm('We will take practicable steps to ensure your personally identifiable information will not be retained by us longer than is necessary for the fulfillment of the purposes.')}
        </div>
      </div>
    </div>
  )
}

export default Privacy;
